import React, { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import { useState } from 'react';
import { BonusCalculationService } from 'services';
import { CloseWeekDialogProps } from './CloseWeekDialogProps';
import { getWeek } from 'date-fns';

export const CloseWeekDialog = ({ open, closeDialog }: CloseWeekDialogProps) => {
	const [selectedWeek, setSelectedWeek] = useState(getWeek(new Date()));
	const weeks = Array.from(Array(52).keys()).map(week => ({ number: week + 1, name: `Week ${week + 1}` }));
	const handleCloseMonth = async () => {
		await BonusCalculationService.processWeeklyBonusChanges(selectedWeek, 0);
		closeDialog();
	};
	return (
		<Dialog open={open} onClose={() => closeDialog()} fullWidth>
			<DialogTitle variant='h5'>Close week</DialogTitle> 
			<DialogContent>
				<Grid item xs={12}>
					{weeks && weeks.length > 0 && (
						<>
							<Autocomplete
								options={weeks}
								getOptionLabel={option => `${option.name}`}
								value={weeks.find(week => week.number === selectedWeek) ?? null}
								onChange={(_, value) => setSelectedWeek(value?.number || 0)}
								renderInput={params => <TextField {...params} label='Week' size='small' />}
							/>
						</>
					)}
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button variant='contained' color='error' onClick={() => closeDialog()}>
					Cancel
				</Button>
				<Button variant='contained' color='primary' onClick={handleCloseMonth}>
					Close Week
				</Button>
			</DialogActions>
		</Dialog>
	);
};
